import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgxCountriesDropdownModule } from 'ngx-countries-dropdown';
import { CommonModule } from '@angular/common';
import { MyGooruModule } from '@gooru/my-gooru-ts';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { HomeComponent } from './pages/home/home.component';
import { OtpService } from './providers/services/otp.service';
import { LoginComponent } from './pages/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpService, NavigatorCoreDirectivesModule, NavigatorCorePipesModule, NavigatorCoreWidgetUiModule } from '@gooru/navigator-core-widget-ui';
import { LoginWithUsernameComponent } from './components/login-with-username/login-with-username.component';
import { TenantListComponent } from './components/tenant-list/tenant-list.component';
import { AuthServiceHelper } from './providers/services/auth.service';
import { environment } from '../environments/environment';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ExploreComponent } from './pages/explore/explore.component';

@NgModule({
  declarations: [
    AppComponent,
    LandingPageComponent,
    HomeComponent,
    LoginComponent,
    LoginWithUsernameComponent,
    TenantListComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ExploreComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    MyGooruModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCountriesDropdownModule,
    NavigatorCoreWidgetUiModule.forRoot({
      ...environment.appConfig,
      deviceType: 'web'
    }),
    NavigatorCorePipesModule,
    NavigatorCoreDirectivesModule,
  ],
  providers: [OtpService,AuthServiceHelper],
  bootstrap: [AppComponent],
})
export class AppModule {}
